import React from 'react'
import { NavLink } from 'react-router-dom'

import { img } from 'assets/online'

import './styles/SignOn.scss'

const REGISTER_URL = 'https://console.underchat.com.br/register'
const WHATSAPP_URL = 'https://wa.me/5562999566428'

const SignUp: React.FC = () => {
  return (
    <div className="row sign-container">
      <div className="sign-content" style={{ width: 760 }}>
        <div className="row sign-title-box ">
          <img src={img.logo} alt="Logo" />
          <h2 className="text-center">Cadastro na nova versao</h2>
          <p className="text-center">
            A versao atual sera descontinuada em 06/07/2026.
          </p>
        </div>

        <div className="sign-up-migration-card">
          <h3>Nova versao do UnderChat</h3>
          <p>
            O UnderChat evoluiu e entrou oficialmente em uma nova fase.
          </p>
          <p>
            Reestruturamos a plataforma do zero, corrigimos limitacoes da versao
            {' '}
            anterior e adicionamos recursos que tornam o atendimento mais rapido,
            {' '}
            organizado e profissional.
          </p>
          <p>
            Se voce ja utilizava o sistema, queremos que conheca essa nova experiencia.
          </p>
          <p>
            Acesse e crie sua conta na nova plataforma:
          </p>

          <a
            className="button sign-up-migration-button"
            href={REGISTER_URL}
            target="_blank"
            rel="noreferrer"
          >
            Abrir novo cadastro
          </a>

          <a
            className="sign-up-help-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
          >
            Duvidas? Clique aqui
          </a>
        </div>

        <p className="text-center underchat-copy-label margin-top-16 margin-bottom-8">
          Ja possui conta?&nbsp;
          <NavLink style={{ color: 'var(--blue)' }} to="/sign-in" >
            Faca login
          </NavLink>
        </p>
        <p className="text-center underchat-copy-label">
          (c) {(new Date()).getFullYear()} UnderChat. Desenvolvido com UnderChat
        </p>
      </div>
    </div>
  )
}

export default SignUp
